module.exports = __webpack_public_path__ + "static/img/1.b839ca48.png";